export default __webpack_public_path__ + "static/Gasoline-9d66229d39831fe16265ff84fc5fc889.png";